// extracted by mini-css-extract-plugin
export default {"container":"variant-map_container__nL-mm"};